import { invoke } from '@web3/utils';
import { ethers } from 'ethers';
import { getRpcUrl, isSopolia, sopoliaRpcUrl } from '../../../utils/common';
import { thirdPartyWallet } from '../../Web3WalletHubCenter';

export const getEvmRpcProvider = invoke(() => {
  const map = new Map<string, ethers.providers.JsonRpcProvider>();
  return (chainCode: string, isNew = false) => {
    const url = isSopolia(chainCode) ? sopoliaRpcUrl : getRpcUrl(chainCode);
    if (isNew) {
      return new ethers.providers.JsonRpcProvider(url);
    }
    const p = map.get(url);
    if (p) {
      return p;
    }
    const provider = new ethers.providers.JsonRpcProvider(url);
    map.set(url, provider);
    return provider;
  };
});

export const getWalletEvmProvider = () => {
  const evmConnector = thirdPartyWallet.activeWalletHub?.EVM;
  if (evmConnector?.provider) {
    return new ethers.providers.Web3Provider(evmConnector.provider);
  }
  return;
};
